import { useState } from 'react';
import { CustomResource } from '../../../../types/CustomResource';

export type RowErrors = {
  crType?: boolean;
  crTitle?: boolean;
};

export function useRowsValidation() {
  const [rowsErrors, setRowsErrors] = useState<Record<string, RowErrors>>({});

  const validate = (row: CustomResource): RowErrors => {
    return {
      crType: !row.crType,
      crTitle: !row.crTitle || !row.crTitle.trim(),
    };
  };

  const setRowErrors = (id: string, errors: RowErrors) =>
    setRowsErrors((prev) => ({ ...prev, [id]: errors }));

  const clearRowErrors = (id: string) =>
    setRowsErrors((prev) => {
      const next = { ...prev };
      delete next[id];
      return next;
    });

  const validateRow = (row: CustomResource) => {
    const errors = validate(row);
    const hasErrors = Object.values(errors).some(Boolean);

    if (hasErrors) {
      setRowErrors(row.crUuid, errors);
      return false;
    }

    clearRowErrors(row.crUuid);
    return true;
  };

  return {
    rowsErrors,
    validateRow,
  };
}
